import React from "react";

import Icon from "./Icon";

export const WalletBalance = ({
  balance,
  setShowPackage,
  showPackage,
}: any) => {
  return (
    <button
      onClick={setShowPackage}
      className="package-btn flex items-center gap-1 theme-text-secondary text-sm font-semibold"
    >
      <div
        className={`rounded p-0 ${
          showPackage ? "bg-gray-50 rounded-full" : "bg-transparent"
        }`}
      >
        <Icon
          name="spiral-logo"
          className={`spiral-icon inline theme-text-secondary transition-all duration-700 ${
            showPackage ? "rotate-180 p-1" : ""
          }`}
        />
      </div>

      <div>
        <div className="balance-text text-[1.05rem] font-bold theme-text-primary">
          {balance ?? 0}
        </div>
      </div>
    </button>
  );
};
